import 'animate.css';
import 'vue-fullpage/vue-fullpage.css';
import 'hammerjs';
import 'velocity-animate';
import 'babel-polyfill';

import Vue from 'vue';
import KsVueFullpage from 'ks-vue-fullpage';
import VueParallaxJs from 'vue-parallax-js';
import i18n from './utils/i18n';
import App from './App';

Vue.use(KsVueFullpage);
Vue.use(VueParallaxJs);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  i18n: i18n.config,
  components: {
    App,
    VueParallaxJs,
  },
  created() {
    i18n.setLocale();
  },
});



// WEBPACK FOOTER //
// ./src/main.js